import Cookies from 'js-cookie'

const TokenKey = 'Access-Token'
const RefreshTokenKey = 'Refresh-Token'
const domain = 'localhost'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setRefreshToken(refreshToken) {
  return Cookies.set(RefreshTokenKey, refreshToken)
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey)
}
